import { useEffect, useState, useContext } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import AuthLayout from '../components/AuthLayout';
import { encryptData } from '../utilities/encryption';
import Swal from 'sweetalert2';
import { verifymail } from '../components/DbServices';

export default function Emailverified() {
  const location = useLocation();
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const [status, setStatus] = useState('verifying'); // 'verifying' | 'success' | 'error'
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');

    if (token) {
      handleVerification(token);
    } else {
      setStatus('error');
      setLoading(false);
    }
  }, [location.search]);

  const handleVerification = async (token) => {
    try {
      const response = await verifymail(token);

      if (response?.status === 200) {
        // 1. Encrypt and Store User Data (Matching your Login logic)
        const encryptedUser = encryptData(response.data);
        localStorage.setItem('user', encryptedUser);
        
        // 2. Update Auth Context
        login(response.token, response.data);

        setStatus('success');
        Swal.fire({
          icon: 'success',
          title: 'Email Verified',
          text: 'Your account is now active and secure.',
          confirmButtonColor: '#6D28D9',
          timer: 3000
        });
      } else {
        setStatus('error');
      }
    } catch (err) {
      console.error('Verification Error:', err);
      setStatus('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title={status === 'success' ? "Account Verified" : "Verification"}
      subtitle={status === 'success' ? "Your email is confirmed. You're ready to go." : "Validating your secure access token..."}
    >
      <div className="text-center py-4">
        {status === 'verifying' && (
          <div className="animate__animated animate__fadeIn">
            <div className="spinner-border text-primary mb-4" style={{ width: '3rem', height: '3rem' }} role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="text-muted fw-medium">Communicating with security console...</p>
          </div>
        )}

        {status === 'success' && (
          <div className="animate__animated animate__zoomIn">
            <div className="mb-4">
               <i className="fas fa-check-circle text-success" style={{ fontSize: '4rem' }}></i>
            </div>
            <button
              onClick={() => navigate('/dashboard')}
              className="btn w-100 py-3 rounded-pill fw-black text-white shadow-lg border-0 transition-all hover-lift"
              style={{ 
                background: 'linear-gradient(135deg, #6D28D9 0%, #06B6D4 100%)',
                letterSpacing: '1px'
              }}
            >
              PROCEED TO CONSOLE <i className="fas fa-arrow-right ms-2"></i>
            </button>
          </div>
        )}

        {status === 'error' && (
          <div className="animate__animated animate__shakeX">
            <div className="mb-4">
               <i className="fas fa-times-circle text-danger" style={{ fontSize: '4rem' }}></i>
            </div>
            <p className="text-danger fw-bold mb-4">The verification link is invalid or has expired.</p>
            <Link to="/login" className="btn btn-light w-100 py-3 rounded-pill fw-bold border-light-subtle">
              BACK TO LOGIN
            </Link>
          </div>
        )}
      </div>

      <style>{`
        .hover-lift:hover { transform: translateY(-2px); filter: brightness(1.1); }
        .fw-black { font-weight: 900 !important; }
      `}</style>
    </AuthLayout>
  );
}